import React from 'react';

import masks from './masks';

interface IProps {
  value: string;
  mask: keyof typeof masks;
  format?: string;
}

const MaskedOutput = ({ value, mask, format }: IProps) => {
  return <span>{applyMask(value, mask, format)}</span>;
};

export default MaskedOutput;

export function applyMask(value: string, mask: keyof typeof masks, format?: string): string {
  return (masks[mask] as any).apply(masks[mask].clean(value), format);
}
